import { Descendant, Editor, Transforms } from 'slate'

import {
  BLOCK_FORMATS,
  CustomEditor,
  TTableCellElement,
} from 'core-components/library/richTextEditor/interface/custom-types'

import { createCell, getCol, getGridTable, isTable, TableCol } from './commonTableHelper'

export const canMerge = (editor: CustomEditor) => {
  const result = { selectedCols: [] as TableCol[], canMergeCells: true }
  if (!editor.selection || !isTable(editor)) {
    return result
  }
  const { gridTable } = getGridTable(editor)
  result.selectedCols = getCol(gridTable, (n: TableCol) => n.cell.selectedCell === true)
  result.canMergeCells = result.selectedCols.length > 1

  return result
}

export const mergeCells = (editor: CustomEditor) => {
  const { selectedCols, canMergeCells } = canMerge(editor)

  if (!canMergeCells || !selectedCols.length) {
    return
  }

  const { xIndex, yIndex } = getGridTable(editor)

  const valuesX = selectedCols.map((col) => col.path[xIndex])
  const valuesY = selectedCols.map((col) => col.path[yIndex])

  const maxXValue = Math.max(...valuesX)
  const minXValue = Math.min(...valuesX)

  const maxYValue = Math.max(...valuesY)
  const minYValue = Math.min(...valuesY)

  const lengthOfMerge = maxXValue - minXValue
  const heightOfMerge = maxYValue - minYValue

  const rememberedNodes = selectedCols.reduce((commonNodes, cell) => {
    try {
      commonNodes.push(
        ...cell.cell.children.filter((item) => !Editor.isEmpty(editor, item as TTableCellElement))
      )
    } catch {}
    return commonNodes
  }, [] as Descendant[])

  // fill the array with an empty paragraph so that after merging
  // several empty cells, the new cell has the correct node structure
  if (!rememberedNodes.length) {
    rememberedNodes.push({
      type: BLOCK_FORMATS.paragraph,
      children: [{ text: '' }],
    })
  }

  const newCell = createCell({
    elements: rememberedNodes,
    rowspan: heightOfMerge + 1,
    colspan: lengthOfMerge + 1,
  })
  const newPath = selectedCols[0].originPath

  try {
    selectedCols
      .filter((cell) => cell.isReal)
      .reverse()
      .forEach((cell) =>
        Transforms.removeNodes(editor, {
          at: cell.originPath,
        })
      )
    Transforms.insertNodes(editor, newCell, {
      at: newPath,
    })
  } catch (e) {
    console.log(e)
  }
}
